<template>
  <v-row justify="start" class="mx-0 mt-2">
    <v-col cols="1" class="px-0">
      <v-img :src="require(`@/assets/svg/${icon}.svg`)" aspect-ratio="1" height="16" width="16" class="p-0 mr-1 d-inline-flex" />
    </v-col>
    <v-col cols="10" align="start" class="pl-1 pt-2">
      <div class="social-post-type-header">{{ title }}</div>
      <div class="caption font-weight-light">
        <div v-if="url" class="caption font-weight-light">
          <div class="mt-1 mb-2">
            <v-icon dense small color="primary" class="mt-n1 pr-1">mdi-open-in-new</v-icon>
            <a :href="url" target="_blank" data-cy="googleReviewLink">Visit the preferred review page</a>
          </div>
        </div>

        <span v-if="formattedMentions.length > 0" :data-cy="`${icon.toLowerCase()}Mentions`">
          Tag the business
          <span v-for="(mention, index) in formattedMentions" :key="`mention-${index}`" class="primary--text">{{ mention }}</span>
        </span>
        <span v-if="formattedMentions.length > 0 && formattedHashtags.length > 0"> and </span>
        <span
          v-if="formattedHashtags.length > 0"
          :class="formattedMentions.length === 0 ? 'formatted-hashtags' : ''"
          :data-cy="`${icon.toLowerCase()}Hashtags`"
        >
          use the {{ 'hashtag' | pluralize(formattedHashtags.length) }}
          <span v-for="(hashtag, index) in formattedHashtags" :key="`hashtag-${index}`" class="primary--text">{{ hashtag }}</span>
        </span>
      </div>
    </v-col>
  </v-row>
</template>

<script>
import Vue from 'vue'

import { formattedHashtags, formattedMentions } from '@/utils/formatsocials'

export default Vue.extend({
  name: 'ClaimSwayOfferTaskOption',

  props: {
    icon: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    url: {
      type: String,
      default: null,
    },
    mentions: {
      type: Array,
      default: () => [],
    },
    hashtags: {
      type: Array,
      default: () => [],
    },
  },

  computed: {
    formattedHashtags: function () {
      return formattedHashtags(this.hashtags, false)
    },
    formattedMentions: function () {
      return formattedMentions(this.mentions)
    },
  },
})
</script>

<style lang="scss" scoped>
.social-post-type-header {
  font-size: 16px;
  font-weight: 400;
}

.formatted-hashtags {
  display: inline-block;
}

.formatted-hashtags:first-letter {
  text-transform: uppercase;
}
</style>
